<template>
  <div class="quiz_container">
    <h2><span style="color:rgb(46,157,208);">巧 </span><span style="color:rgb(233,147,19);">手 </span><span style="color:rgb(221,84,26);">智 </span><span style="color:rgb(44,163,56);">心 </span>STEM 课程教研活动</h2>
    <!-- 绑定老师账号区域 -->
    <!-- 巧智教研图标区域 -->
    <div id="stackbar_container" style="width:100%;">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryInfo: {
        query: '',
        token: ''
      }
    }
  },
  created() {
    this.queryInfo.token = window.sessionStorage.getItem('token')
  },
  mounted() {
    this.refreshtimer = setInterval(() => {
      setTimeout(this.getQuestionList, 0)
    }, 1000 * 5) /* 5000 */
    this.drawBar()
  },
  beforeDestroy() {
    clearInterval(this.refreshtimer)
    this.refreshtimer = null
  },
  methods: {
    drawBar() {
      // var myChart = this.$echarts.init(document.getElementById('stackbar_container'))
      var dom = document.getElementById('stackbar_container')
      var myChart = this.$echarts.init(dom, null, {
        renderer: 'canvas',
        useDirtyRect: false
      })
      var option
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: ['学生1', '学生2', '学生3', '学生4', '学生5', '学生6', '学生7']
        }],
        yAxis: [{
          type: 'value'
        }],
        series: [{
          name: '动手',
          type: 'bar',
          stack: 'STEM',
          emphasis: {
            focus: 'series'
          },
          data: [20, 32, 10, 34, 50, 30, 20]
        },
        {
          name: '数学',
          type: 'bar',
          stack: 'STEM',
          emphasis: {
            focus: 'series'
          },
          data: [22, 12, 51, 34, 20, 33, 31]
        },
        {
          name: '物理',
          type: 'bar',
          stack: 'STEM',
          emphasis: {
            focus: 'series'
          },
          data: [10, 32, 21, 24, 10, 33, 41]
        },
        {
          name: '总分',
          type: 'bar',
          stack: '',
          data: [100, 99, 98, 99, 98, 96, 98],
          label: {
            normal: {
              show: true,
              postion: 'top',
              textStyle: { color: 'red' }
            }
          },
          itemStyle: {
            normal: {
              color: 'rgba(128, 128, 128, 0)'
            }
          },
          z: -1,
          barGap: '-100%'
        }]
      }
      if (option && typeof option === 'object') {
        myChart.setOption(option)
      }
      window.addEventListener('resize', myChart.resize)
    },
    refreshBarOption() {
      this.drawBar()
    }
  }
}
</script>

<style lang="less" scoped>
.quiz_container{
  #stackbar_container{
    height: 360px;
    width: 800px;
    text-align: center;
  }
  >h2{
  font-weight: 900;
  text-align: center;
  font-size: 30px;
  }
  >div h3{
    padding-left: 20px;
  }
  >div h3 span{
      font-size: 50px;
      color: coral;
      font-weight: 600;
  }
  .BindingButtonBox{
    // float: right;
    // position: fixed;
    // width: 800px;
    margin-right: 20px;
    position: relative;
  }
  #BindingButton{
    float: right;
    margin-right: 20px;
    position: relative;
    z-index: 10;
    // cursor: pointer;
  }
  .quiz_box{
    display: flex;
    justify-content: space-between;
    >div{
      margin-top: 40px;
      margin-right: 30px;
    }
  }
}
</style>
